export const environment = {
    production: false,
    hmr: false,
    nombre: "Desarrollo",
    apis: "https://devapigw.pagaredigital.cl/pagare",
    tokenApi: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwSHdheEJuZXp5Z05od0c0NVFYcmVZIiwibmFtZSI6IlBBR0FSRSIsImlhdCI6MTY1OTM4ODU2NTYyMX0.8VEFsWe90veODKtu4Yb88cGGjFk0Vig2L6Vm3Hkl0i4"
};
